var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"w-[48px] h-[48px] object-cover object-center cursor",attrs:{"src":_vm.src},on:{"click":_vm.handlePreviewClick}}),_c('ys-image-preview',{ref:"imagePreviewRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }